import { render } from "./AboutVideo.vue?vue&type=template&id=b840e694&scoped=true"
import script from "./AboutVideo.vue?vue&type=script&lang=js"
export * from "./AboutVideo.vue?vue&type=script&lang=js"

import "./AboutVideo.vue?vue&type=style&index=0&id=b840e694&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b840e694"]])

export default __exports__